export const URI_CARDS = '/';
